import { memo } from 'react';
import { classNames } from '~/utils/classNames';

interface IntegrationHomeButtonProps {
  title: string;
  icon: string;
  onClick?: VoidFunction;
}

export const IntegrationHomeButton = memo(({ title, icon, onClick }: IntegrationHomeButtonProps) => (
  <button
    className={classNames(
      'flex items-center gap-1.5 border border-bolt-elements-borderColor rounded-full px-3 py-1.5 text-xs transition-theme',
      'text-bolt-elements-textSecondary hover:text-bolt-elements-textPrimary bg-gray-50 dark:bg-gray-950 hover:bg-gray-100 dark:hover:bg-gray-900',
    )}
    onClick={onClick}
  >
    <span
      className={classNames(
        'w-4 h-4 block group-hover:bg-gray-900 dark:group-hover:bg-gray-100 transition-theme',
        icon,
      )}
    />
    <span className="group-hover:text-bolt-elements-textPrimary transition-theme">{title}</span>
  </button>
));

IntegrationHomeButton.displayName = 'IntegrationHomeButton';
